<template>
    <div class="App">
        <div class="fromBox">
            <div class="complain-title gs-ellipsis-3">
                {{ contentTitle }}
            </div>

            <div class="complainSelect complainSelect-Type">
                <div class="complainSelect-Title">类型</div>

                <div class="complainSelect-Content">{{ contentTypesCur }}</div>
                <!-- @click="complainTypePopup = true" -->
            </div>

            <div class="complainSelect complainSelect-Reason">
                <div class="complainSelect-Title">
                    <div>理由</div>
                    <div class="gz" @click="goGz">
                        举报规则<img src="https://image.gamersky.com/webimg13/tip.png" />
                    </div>
                </div>
                <div class="complainSelect-Content complainSelect-select" @click="openComplainReasonPopup">
                    {{ ReasonsItemCur }}
                </div>
            </div>

            <div
                class="complainPopup complainTypePopup"
                @click.stop="closePopup('complainTypePopup')"
                v-show="complainTypePopup"
            >
                <div class="complainPopup-Box" @click.stop="" ref="complainTypePopup">
                    <div class="complainPopup-Title">类型</div>
                    <div class="complainPopup-List">
                        <div
                            class="complainPopup-Item complainPopup-ItemType"
                            :class="{ cur: item == contentTypesCur }"
                            v-for="item in contentTypes"
                            :key="item"
                            v-show="item != disableType"
                            @click.stop="selected('complainTypePopup', 'contentTypesCur', item)"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div class="complainPopup-close" @click.stop="closePopup('complainTypePopup')">取消</div>
                </div>
            </div>
            <div
                class="complainPopup complainReasonPopup"
                @click.stop="closePopup('complainReasonPopup')"
                v-show="complainReasonPopup"
            >
                <div class="complainPopup-Box" @click.stop="" ref="complainReasonPopup">
                    <div class="complainPopup-Title">原因</div>
                    <div class="complainPopup-List" v-if="contentTypesCur != '举报内容'">
                        <div
                            class="complainPopup-Item"
                            :class="{ cur: item == ReasonsItemCur }"
                            v-for="item in Reasonslist"
                            :key="item"
                            @click.stop="selected('complainReasonPopup', 'ReasonsItemCur', item)"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div class="popup_list" v-else>
                        <div class="list" v-for="(item, index) in type == 'news' ? newslist : commentlist" :key="index">
                            <div class="title">{{ item.title }}</div>
                            <div class="select_item">
                                <div
                                    class="item complainPopup-Item"
                                    ref="item"
                                    :class="{ cur: v == ReasonsItemCur }"
                                    v-for="(v, i) in item.selectList"
                                    :key="i"
                                    @click.stop="selected('complainReasonPopup', 'ReasonsItemCur', v)"
                                >
                                    <div>{{ v }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="complainPopup-close" @click.stop="closePopup('complainReasonPopup')">取消</div>
                </div>
            </div>
            <textarea
                class="complain-area"
                maxlength="300"
                placeholder="请输入举报理由（选填，不超过300个汉字）"
                v-model="description"
            ></textarea>
            <div class="upDataImage">
                <div class="imageSelect" v-for="(item, key) in imageFiles" :key="key">
                    <input
                        v-if="isiphone"
                        type="file"
                        accept="image/*"
                        ref="inputfile"
                        @change="inputFileChange(key, $event)"
                    />
                    <input v-else type="file" accept="image/*" ref="inputfile" @click="inputfile(key, $event)" />
                    <img v-if="imageFiles[key]" :src="imageFiles[key].listImageUrl" alt="" />
                    <i v-if="imageFiles[key]" @click="closeImage(key)"></i>
                </div>
            </div>
            <input class="complain-input" type="text" v-model="authorPhoneNumber" placeholder="请输入手机号" />
            <input class="complain-input" type="text" v-model="authorEMail" placeholder="请输入邮箱" />
        </div>

        <button class="complain-button" @click="submitFeedback()">提交</button>
    </div>
</template>
<script>
export default {
    name: "App",
    data() {
        return {
            CurrentUserId: GSAppJsApi.User.getCurrentUserId(),
            complainTypePopup: false,
            complainReasonPopup: false,
            contentTitle: "",
            contentTypes: [],
            contentFeedbackReasons: [],
            Reasonslist: [],
            contentUrl: this.$ajax.getQueryString("contentUrl"),
            imageFiles: [null, null, null],
            contentTypesCur: "",
            disableType: "",
            ReasonsItemCur: "请选择理由",
            description: "",
            authorPhoneNumber: "",
            authorEMail: "",
            ColorMode: this.$ajax.getQueryString("gsAppColorMode") || "light",
            gsAppInfo: "",
            httpLoading: true,

            type: "",

            newslist: [
                {
                    title: "政治敏感",
                    selectList: ["涉政不当内容", "危害国家言论"]
                },
                {
                    title: "违法违规",
                    selectList: ["淫秽色情", "赌博诈骗", "涉及违禁物品", "包含危险链接", "教唆/诱导自杀", "侮辱英烈"]
                },
                {
                    title: "观感不适",
                    selectList: ["血腥暴力", "低俗内容", "猎奇邪典"]
                },
                {
                    title: "侵权相关",
                    selectList: ["侵害企业权益", "侵害个人权益", "侵犯隐私"]
                },
                {
                    title: "未成年相关",
                    selectList: ["未成年不宜浏览", "未成年不良行为"]
                },
                {
                    title: "造谣及不实信息",
                    selectList: ["标题内容不符", "造谣抹黑", "虚假不实信息"]
                },
                {
                    title: "不友善行为",
                    selectList: ["引战骚扰", "制造对立", "剧透"]
                },
                {
                    title: "违反公序良俗",
                    selectList: ["网络暴力", "其它"]
                }
            ],

            commentlist: [
                {
                    title: "政治敏感",
                    selectList: ["涉政不当内容", "危害国家言论"]
                },
                {
                    title: "违法违规",
                    selectList: ["淫秽色情", "赌博诈骗", "涉及违禁物品", "包含危险链接", "教唆/诱导自杀", "侮辱英烈"]
                },
                {
                    title: "观感不适",
                    selectList: ["血腥暴力", "低俗内容", "猎奇邪典"]
                },
                {
                    title: "侵权相关",
                    selectList: ["侵害企业权益", "侵害个人权益", "侵犯隐私"]
                },
                {
                    title: "未成年相关",
                    selectList: ["未成年不宜浏览", "未成年不良行为"]
                },
                {
                    title: "造谣及不实信息",
                    selectList: ["造谣抹黑", "虚假不实信息"]
                },
                {
                    title: "不友善行为",
                    selectList: ["人身攻击", "引战骚扰", "制造对立", "侮辱攻击游民/作者", "剧透"]
                },
                {
                    title: "垃圾信息",
                    selectList: ["广告营销", "无意义刷屏"]
                },
                {
                    title: "违反公序良俗",
                    selectList: ["网络暴力", "炫富", "其它"]
                }
            ],

            systemStatusBarHeight: 44,

            isiphone: false
        };
    },
    mounted() {
        this.AorI();
        let contentUrl = this.$ajax.getQueryString("contentUrl");
        if (contentUrl) {
            if (contentUrl.indexOf("gsCommentId") != -1 || contentUrl.indexOf("gsGameCommentId") != -1) {
                this.type = "comment";
            } else if (contentUrl.indexOf("club.gamersky.com") != -1) {
                this.type = "comment";
            } else {
                this.type = "news";
            }
        } else {
            this.type = "news";
        }
        this.$nextTick(() => {
            if (this.ColorMode == "dark") {
                window.document.documentElement.setAttribute("data-theme", "Dark");
            } else {
                window.document.documentElement.removeAttribute("data-theme");
            }
            GSAppJsApi.UI.registerSetPageUI(function (theme) {
                if (theme == "Dark") {
                    window.document.documentElement.setAttribute("data-theme", "Dark");
                } else {
                    window.document.documentElement.removeAttribute("data-theme");
                }
            });
        });
        let that = this;
        GSAppJsApi.UI.getUIEnvironmentParams(function (params) {
            that.systemStatusBarHeight = params.systemStatusBarHeight;
        });
        this.GetFeedBackPage();
    },
    watch: {
        contentTypesCur(val) {
            console.log(val);
            for (let i = 0; i < this.contentFeedbackReasons.length; i++) {
                if (this.contentFeedbackReasons[i].feedbackType == val && this.contentTypesCur != "举报内容") {
                    this.Reasonslist = this.contentFeedbackReasons[i].feedbackReasons;
                    this.ReasonsItemCur = this.Reasonslist[0];
                    console.log(this.Reasonslist);
                    break;
                }
            }
        },
        complainTypePopup(val) {
            if (val) {
                setTimeout(() => {
                    this.$refs.complainTypePopup.classList.add("cur");
                }, 0);
            } else {
                setTimeout(() => {
                    this.$refs.complainTypePopup.classList.remove("cur");
                }, 0);
            }
            if (this.contentTypesCur == "举报内容") {
                this.disableType = "举报用户";
            } else if (this.contentTypesCur == "举报用户") {
                this.disableType = "举报内容";
            } else {
                this.disableType = "";
            }
        },
        complainReasonPopup(val) {
            if (val) {
                setTimeout(() => {
                    this.$refs.complainReasonPopup.classList.add("cur");
                }, 0);
            } else {
                setTimeout(() => {
                    this.$refs.complainReasonPopup.classList.remove("cur");
                }, 0);
            }
        }
    },
    methods: {
        submitFeedback() {
            let that = this;
            // if (that.description.length <= 0) {
            //     that.$toast({ message: "请输入举报理由" });
            //     return;
            // }

            let isMinor = this.$utils.cookie("gsAppIsMinor") || false;

            if (that.authorPhoneNumber.length > 0 && !that.validatePhone(that.authorPhoneNumber)) {
                that.$toast({ message: "请输入正确的手机号码" });
                return;
            }
            if (that.authorEMail.length > 0 && !that.validateEmail(that.authorEMail)) {
                that.$toast({ message: "请输入正确的邮箱" });
                return;
            }
            if (that.ReasonsItemCur == "请选择理由") {
                that.$toast({ message: "请选择举报理由" });
                return;
            }

            if (that.httpLoading) {
                that.httpLoading = false;
                GSAppJsApi.Environment.getAppInfo(function (response) {
                    if (that.contentTypesCur == "意见反馈") {
                        that.gsAppInfo = `\n---------------\n手机设备型号\n${response.deviceName}\n手机系统版本号\n${response.systemName}\nAPP版本号\n${response.appVersion}`;
                    }
                    that.$ajax
                        .post("//router.gamersky.com/@/feedback/submitFeedback/6.0.0/" + that.CurrentUserId, {
                            // .post("//router-test.gamersky.com/@133_9083/feedback/submitFeedback/6.0.0/" + that.CurrentUserId, {

                            contentType: that.contentTypesCur,
                            contentUrl: that.contentUrl,
                            contentFeedbackReason: that.ReasonsItemCur,
                            description: that.description + that.gsAppInfo,
                            imageInfes: that.imageFiles,
                            authorPhoneNumber: that.authorPhoneNumber,
                            authorEMail: that.authorEMail,
                            isMinor: isMinor
                        })
                        .then(response => {
                            if (response.error == "") {
                                if (that.contentTypesCur == "意见反馈") {
                                    that.$toast({ message: "提交成功，感谢您的反馈！" });
                                } else {
                                    that.$toast({ message: "举报成功！" });
                                }
                                setTimeout(() => {
                                    GSAppJsApi.UI.close();
                                }, 2000);
                            } else {
                                that.$toast({ message: "提交失败" });
                            }
                            setTimeout(() => {
                                that.httpLoading = true;
                            }, 500);
                        })
                        .catch(error => {
                            that.$toast({ message: "提交失败" });
                        });
                });
            }
        },
        GetFeedBackPage() {
            this.$ajax
                .get("//router.gamersky.com/@/feedbackPage/index/6.0.0/" + this.CurrentUserId, {
                    // .get("//router-test.gamersky.com/@133_9083/feedbackPage/index/6.0.0/" + this.CurrentUserId, {
                    contentUrl: this.contentUrl
                })
                .then(response => {
                    if (response.error == "") {
                        this.contentTitle = response.contentTitle;
                        this.contentTypes = response.feedbackTypes;
                        this.contentFeedbackReasons = response.feedbackReasons;
                        this.contentTypes.map(item => {
                            if (item == response.defaultFeedbackType) {
                                this.contentTypesCur = item;
                                console.log(this.contentTypesCur);
                            }
                        });
                        for (let i = 0; i < this.contentFeedbackReasons.length; i++) {
                            if (
                                this.contentFeedbackReasons[i].feedbackType == this.contentTypesCur &&
                                this.contentTypesCur != "举报内容"
                            ) {
                                this.ReasonsItemCur = this.contentFeedbackReasons[i].feedbackReasons[0];
                                break;
                            }
                        }
                    }
                });
        },
        openComplainReasonPopup() {
            this.complainReasonPopup = true;
            if (this.contentTypesCur == "举报内容") {
                this.$nextTick(() => {
                    this.$refs.complainReasonPopup.style.height =
                        window.innerHeight - this.systemStatusBarHeight + "px";
                });
            }
        },
        goGz() {
            // window.location.href = "https://www.gamersky.com/news/202412/1858998.shtml";
            let ContentUrl = "https://www.gamersky.com/news/202412/1858998.shtml";
            let a = document.createElement("a");
            let gsAppOpenWithNewWindow =
                ContentUrl.indexOf("?") != -1 ? "&gsAppOpenWithNewWindow=true" : "?gsAppOpenWithNewWindow=true";
            a.href = ContentUrl + gsAppOpenWithNewWindow;
            a.click();
            a.remove();
        },
        AorI() {
            const u = navigator.userAgent.toLowerCase();
            if (u.indexOf("Android") != -1) {
                this.isiphone = false;
            } else if (u.indexOf("iphone") != -1) {
                this.isiphone = true;
            }
        },
        inputfile(index) {
            // this.$refs.inputfile.click();
            let that = this;
            GSAppJsApi.UI.openImageSelector("JuBao", 1, function (e) {
                if (e.imageInfes && e.imageInfes.length > 0) {
                    // that.imageFiles=e.imageInfes
                    e.imageInfes.forEach(item => {
                        let imageInfo = {
                            listImageUrl: item.listImageUrl,
                            contentImageUrl: item.contentImageUrl,
                            sourceImageUrl: item.sourceImageUrl,
                            imageWidth: item.imageWidth,
                            imageHeight: item.imageHeight
                        };
                        that.$set(that.imageFiles, index, imageInfo);
                    });
                }
            });
        },
        inputFileChange(num, event) {
            let files = event.currentTarget.files;
            this.uploadpic(files[0], num);
        },
        uploadpic(file, index) {
            let formData = new FormData();
            formData.append("files", file);
            this.$ajax.post("//i.gamersky.com/uploadpic/index", formData).then(response => {
                if (response.status == "ok") {
                    let imageInfo = {
                        listImageUrl: response.tiny,
                        contentImageUrl: response.small,
                        sourceImageUrl: response.original,
                        imageWidth: response.width,
                        imageHeight: response.height,
                        imageTags: response.imageclass != "none" ? [response.imageclass] : []
                    };
                    this.$set(this.imageFiles, index, imageInfo);
                }
            });
        },
        closeImage(key) {
            this.$set(this.imageFiles, key, null);
        },
        closePopup(type) {
            this.$refs[type].classList.remove("cur");
            setTimeout(() => {
                this[type] = false;
            }, 300);
        },
        selected(type, key, val) {
            let that = this;
            console.log(that.$refs[type].classList);
            that.$refs[type].classList.remove("cur");
            setTimeout(() => {
                that[type] = false;
                that[key] = val;
            }, 300);
        },
        popupSelected(v, i) {},

        validatePhone(val) {
            return /^[1][3-9][0-9]{9}$/.test(val);
        },
        validateEmail(val) {
            let re = /^([\s\S]*)+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
            return re.test(val);
        }
    }
};
</script>
<style lang="scss" scoped>
.gs-ellipsis-3 {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.App {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100%;
    padding: 20px 16px 0;
    box-sizing: border-box;

    .complain-title {
        font-size: 20px;
        @include Color1($Color1);
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 24px;
    }

    .complainSelect {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 48px;
        box-sizing: border-box;

        .complainSelect-Title {
            height: 100%;
            line-height: 48px;
            font-size: 16px;
            @include Color1($Color1);

            .gz {
                font-family: PingFang SC;
                font-size: 11px;
                font-weight: normal;
                line-height: normal;
                text-align: right;
                letter-spacing: 0px;
                font-variation-settings: "opsz" auto;
                color: #999999;
                display: flex;
                align-items: center;

                img {
                    width: 10px;
                    height: 10px;
                    margin-left: 2px;
                }
            }
        }

        .complainSelect-Content {
            flex: 1;
            width: 0;
            height: 100%;
            line-height: 48px;
            font-size: 14px;
            @include Color2($Color2);
            text-align: right;

            &.complainSelect-select {
                padding-right: 18px;
                background: url("./assets/image/icon_jiantou.png") no-repeat right center / 10px;
            }
        }
    }

    .complainPopup {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        width: 100%;
        height: 100%;
        @include Mark($Mark);

        .complainPopup-Box {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translate(-50%, 100%);
            width: 100%;
            height: 406px;
            padding: 20px 0 34px;
            box-sizing: border-box;
            @include Background2($Background2);
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
            overflow: hidden;
            transition: all 0.3s;

            &.cur {
                transform: translate(-50%, 0);
            }

            .complainPopup-Title {
                width: 100%;
                height: 32px;
                font-size: 15px;
                @include Color1($Color1);
                line-height: 32px;
                font-weight: bold;
                margin-bottom: 8px;
                padding: 0 16px;
                box-sizing: border-box;
            }

            .complainPopup-List {
                display: flex;
                flex-wrap: wrap;
                width: calc(100% + 9px);
                height: 0;
                flex: 1;
                align-content: flex-start;
                // justify-content: space-around;
                padding: 0 16px;
                box-sizing: border-box;

                .complainPopup-Item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: auto;
                    min-width: 80px;
                    height: 28px;
                    padding: 0 8px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    @include Background4($Background4);
                    font-size: 12px;
                    @include Color1($Color1);
                    cursor: pointer;
                    -webkit-tap-highlight-color: transparent;
                    border-radius: 2px;
                    overflow: hidden;
                    box-sizing: border-box;

                    &.cur {
                        @include ButtonBackground($ButtonBackground);
                        @include ButtonColor($ButtonColor);
                    }
                }
            }

            .popup_list {
                .complainPopup-Item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: calc(30% - 10px);
                    min-width: 100px;
                    height: 28px;
                    padding: 0 8px;
                    // margin-right: 8px;
                    // margin-bottom: 8px;
                    @include Background4($Background4);
                    font-size: 12px;
                    @include Color1($Color1);
                    cursor: pointer;
                    -webkit-tap-highlight-color: transparent;
                    border-radius: 2px;
                    overflow: hidden;
                    box-sizing: border-box;

                    &.cur {
                        @include ButtonBackground($ButtonBackground);
                        @include ButtonColor($ButtonColor);
                    }
                }
            }

            .complainPopup-close {
                display: flex;
                justify-content: center;
                align-items: center;
                justify-self: flex-end;
                width: 100%;
                height: 50px;
                border-top: 1px solid;
                @include Border1($Border1);
                font-size: 16px;
                @include Color1($Color1);
                cursor: pointer;
                -webkit-tap-highlight-color: transparent;
                padding: 5 16px 0;
                box-sizing: border-box;
            }
        }
    }

    .complain-radio {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .complain-radio-item {
            display: flex;
            align-items: center;
            margin-right: 8px;
            height: 30px;
            border-radius: 4px;
            border: 0.5px solid #eeeeee;
            padding: 0 10px;
            font-size: 14px;
            color: #333;
            overflow: hidden;

            &:last-of-type {
                margin: 0;
            }

            &.contentTypesCur {
                color: #fff;
                background: #eb413d;
                border-color: #eb413d;
            }
        }
    }

    .contentFeedbackReasonsBox {
        display: block;
        margin-bottom: 4px;

        .contentFeedbackReasons {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .contentFeedbackReasons-item {
                display: flex;
                align-items: center;
                margin-right: 8px;
                height: 30px;
                border-radius: 4px;
                border: 0.5px solid #eeeeee;
                padding: 0 10px;
                font-size: 14px;
                color: #333;
                overflow: hidden;
                margin-bottom: 8px;

                &.ReasonsItemCur {
                    color: #fff;
                    background: #eb413d;
                    border-color: #eb413d;
                }
            }
        }
    }

    .complain-area {
        display: block;
        padding: 12px 14px;
        width: 100%;
        border: 0.5px solid;
        @include Border1($Border1);
        box-sizing: border-box;
        height: 133px;
        resize: none;
        margin-bottom: 12px;
        margin-top: 38px;
        box-shadow: none;
        -webkit-appearance: none;
        @include Color1($Color1);
        font-size: 14px;
    }

    .upDataImage {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 28px;

        .imageSelect,
        .imageItem {
            position: relative;
            display: block;
            width: 76px;
            height: 76px;
            background: #f5f7f9 url("./assets/image/icon_Tupian.png") no-repeat center / 24px;
            @include Background4($Background4);
            border-radius: 4px;
            margin-right: 12px;
            margin-bottom: 12px;
            cursor: pointer;
            -webkit-tap-highlight-color: transparent;

            input {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                height: 100%;
                opacity: 0;
            }

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
                overflow: hidden;
            }

            i {
                display: block;
                position: absolute;
                right: -4px;
                top: -4px;
                width: 12px;
                height: 12px;
                background: url("./assets/image/icon_close.png") no-repeat center / 12px;
            }

            &:nth-child(4n) {
                margin-right: 0;
            }
        }
    }

    .complain-input {
        display: block;
        padding: 0;
        height: 44px;
        width: 100%;
        margin-bottom: 8px;
        border-bottom: 0.5px solid;
        @include Border1($Border1);
        font-size: 16px;
        @include Color1($Color1);
    }

    .complain-button {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 44px auto;
        width: calc(100% - 32px);
        height: 40px;
        border-radius: 4px;
        @include ButtonBackground($ButtonBackground);
        @include ButtonColor($ButtonColor);
        font-size: 16px;
        cursor: pointer;
    }
}

.popup_list {
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 16px;
    margin-bottom: 4px;

    .title {
        @include Color1($Color1);
    }
}

.list {
    width: 100%;
    margin-bottom: 12px;

    .title {
        font-family: PingFang SC;
        font-size: 15px;
        font-weight: 500;
        line-height: 32px;
        letter-spacing: 0px;
        /* 一级文字#222222#D7D7D9 */
        color: #222222;
        margin-bottom: 10px;
    }

    .select_item {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .item {
        width: 107px;
        height: 28px;
        padding: 5px 2px;
        border-radius: 4px;
        background: #f5f7f9;
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: normal;
        line-height: 18px;
        text-align: center;
        letter-spacing: 0px;
        /* 一级文字#222222#D7D7D9 */
        color: #222222;
        box-sizing: border-box;
    }
}
</style>
